import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import siteMessage from "@insite/client-framework/SiteMessage";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";

import React from "react";
import { css } from "styled-components";

const enum fields {
    showIcon = "showIcon",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.showIcon]: boolean;
    };
}

export interface HazrdousMaterialStyle {
    alertText?: InjectableCss;
    hazardousContainer?: InjectableCss;
}
export const hazrdousMaterialStyle: HazrdousMaterialStyle = {
    alertText: {
        css: css`
            color: #323232;
            font-weight: 400;
            font-size: 12px;
            line-height: 16px;
            padding-left: 20px;
            padding-top: 10px;
            padding-bottom: 10px;
            padding-right: 35px;
            
        `,
    },
    hazardousContainer: {
        css: css`
            background-color: #FFF4EF;
            border-top-style: solid;
            border-color: #DB8054;
            border-width: 1px;
            margin-top: 10px;
        `,
    },
};
const styles = hazrdousMaterialStyle;

type Props = OwnProps & HasProduct;

const HazrdousMaterialWarning: React.FC<Props> = ({ product, id, fields }) => {
    if (!product || !product.properties || typeof product.properties.erP_HAZARDOUS_MATERIAL !== "string") {
        return null;
    }

    return (
        <>
            {product.properties.erP_HAZARDOUS_MATERIAL.toLocaleLowerCase() === "true" ? (
                <StyledWrapper {...styles.hazardousContainer}>
                    <StyledWrapper {...styles.alertText}>{siteMessage("Hazardous_Material_Warning")}</StyledWrapper>
                </StyledWrapper>
            ) : null}
        </>
    );
};

const widgetModule: WidgetModule = {
    component: withProduct(HazrdousMaterialWarning),
    definition: {
        group: "Common",
        displayName: "HazrdousMaterialWarning",
        fieldDefinitions: [
            {
                name: fields.showIcon,
                displayName: "Show Icon",
                editorTemplate: "CheckboxField",
                defaultValue: false,
                isEnabled: () => true,
                fieldType: "General",
                sortOrder: 1,
            },
        ],
    },
};

export default widgetModule;
